import { render, staticRenderFns } from "./UnreadMovementsCard.vue?vue&type=template&id=6e24f264&scoped=true&"
import script from "./UnreadMovementsCard.vue?vue&type=script&lang=js&"
export * from "./UnreadMovementsCard.vue?vue&type=script&lang=js&"
import style0 from "./UnreadMovementsCard.vue?vue&type=style&index=0&id=6e24f264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24f264",
  null
  
)

export default component.exports